import Combobox, { MenuItem } from '@ingka/combobox';
import React, { useState, useEffect } from 'react';
import InputField from '@ingka/input-field';
import FormField from '@ingka/form-field';
import styled from 'styled-components';
import { PageFEDSA } from 'components/layout';
import Commodities from 'pages/Commodities/commodities';
import Button from '@ingka/button';
import { Select, Option } from '@ingka/select';
import { manualSubmit, resetManualEntry } from 'Action/manualSubmitAction';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'Store/store';
import Toast from '@ingka/toast';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/forms/dist/style.css';
import { useNavigate } from 'react-router-dom';
import AssociatedDds from 'pages/AssociatedDDS/associatedDds';
import { masterDataManual } from 'Action/manualDropDownAction';
import 'react-datepicker/dist/react-datepicker.css';
import SupplierDetails from 'pages/SupplierDetails/supplierDetails';
import { manualValidate } from 'Action/manualValidateAction';
import { MANUAL_SUPPLIER_VALIDATE } from 'Action/types';
import { setCommodityRows } from 'Action/commodityDetailsStateAction';

const ManualEntry = (props: any) => {
  const { masterData } = useSelector((state: RootState) => state.dropDownMasterData);
  const { manualFetchData, manualValidateSubmit } = useSelector(
    (state: RootState) => state.manualValidateDetails
  );
  const { commodityFieldRows } = useSelector((state: RootState) => state.commodityState);
  const [toastOpen, setToastOpen] = useState<any>(false);
  const [isValidate, setIsValidate] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');

  const [submitError, setSubmitError] = useState(null);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const [supplierRows, setSupplierRows] = useState([
    {
      supplierId: '',
      ddsReferenceNumber: '',
      ddsVerificationNumber: '',
      ddsActivityType: '',
      ddsFilingDate: null,
    },
  ]);
  const [countryActivity, setCountryActivity] = useState([
    { countryOfActivity: '', borderCrossCountry: '' },
  ]);
  const [operatorRows, setOperatorRows] = useState([
    {
      operatorIdentifier: '',
      operatorValue: '',
      operatorName: '',
      operatorCountry: '',
      operatoraddress: ' ',
    },
  ]);
  const [productRows, setProductRows] = useState([
    { productName: '', productIdType: '', gtin: '', validFrom: null, validUntil: null },
  ]);
  const [oldDdsRows, setOldDdsRows] = useState([
    {
      oldDdsFirstProduction: '',
      oldDdsVerificationNumber: '',
      oldDdsActivityType: '',
      oldDdsFilingDate: null,
    },
  ]);

  const [productionPlaceRows, setProductionPlaceRows] = useState([
    {
      productionPlace: '',
      type: '',
      coordinates: '',
      area: null,
      harvestValidFrom: '',
      harvestValidTo: '',
    },
  ]);
  const [producerRows, setProducerRows] = useState([{ producerName: '', producerCountry: '' }]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [isFilingImport, setIsFilingImport] = useState(false);
  const [submitToastMessage, setSubmitToastMessage] = useState('');
  const [frnId, setFrnId] = useState('');
  const [isCopied, setIsCopied] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const { manualEntryData } = useSelector((state: RootState) => state.manualEntrySubmitData);
  const { error, errorMessage, errorType } = useSelector((state: RootState) => state.error);
  const navigate = useNavigate();

  useEffect(() => {
    if (manualFetchData) {
      const transformedCommodities = manualFetchData.commodities?.map((commodity) => {
        const { hsHeading, descriptionOfGoods, goodsMeasure, producers = [] } = commodity;

        const { volume = 0, netWeight = 0, numberofUnits = 0 } = goodsMeasure || {};

        const producerAccordions = producers.map((producer) => {
          const { producerCountry, geometryGeoJson } = producer;

          const productionPlaceRows =
            geometryGeoJson?.features?.map((feature) => ({
              productionPlace: '',
              type: feature.geometry?.type || '',
              coordinates: JSON.parse(feature.geometry?.coordinates || '[]'),
              Area: feature.properties?.area || '',
              id: null,
            })) || [];

          return {
            producerRows: [{ producerName: '', producerCountry }],
            productionPlaceRows,
          };
        });

        return {
          hsHeader: hsHeading || '',
          descriptionOfGoods: descriptionOfGoods || '',
          productName: '',
          productId: '',
          itemSupplier: '',
          validFrom: '',
          validUntil: '',
          volume: volume || '0',
          netWeight: netWeight || '0',
          numberofUnits: numberofUnits || '0',
          producerAccordions: producerAccordions.length
            ? producerAccordions
            : [
                {
                  producerRows: [{ producerName: '', producerCountry: '' }],
                  productionPlaceRows: [
                    {
                      productionPlace: '',
                      type: '',
                      coordinates: '',
                      area: '',
                      harvestValidFrom: '',
                      harvestValidTo: '',
                      id: null,
                    },
                  ],
                },
              ],
        };
      });

      dispatch(setCommodityRows(transformedCommodities));
    }
  }, [manualFetchData]);

  const handleValidate = async (payload) => {
    try {
      const response = await dispatch(manualValidate(payload, MANUAL_SUPPLIER_VALIDATE));
      if (response && response?.status === 200) {
        const data = response.data;
        setIsFilingImport(true);
        setIsValidate(true);
        setCommodityRows(
          data.commodities?.map((item) => ({
            hsHeader: item.hsHeading || '',
            descriptionOfGoods: item.descriptionOfGoods || '',
            netWeight: item.netWeight || 0,
            numberofUnits: item.supplementaryUnit || 0,
            volume: item.volume || 0,
            universalUnit: item.supplementaryUnitQualifier || null,
          })) || []
        );

        setProductRows(
          data.commodities?.map((item) => ({
            productName: item.gtin || '',
            productIdType: item.itemSupplier?.itemType || '',
            productId: item.itemSupplier?.itemNo || '',
          })) || []
        );

        setProducerRows(
          data.commodities?.flatMap(
            (item) =>
              item.producers?.map((producer) => ({
                producerName: producer.name || '',
                producerCountry: producer.country || '',
              })) || []
          )
        );

        setProductionPlaceRows(
          data.commodities?.flatMap(
            (item) =>
              item.producers?.flatMap(
                (producer) =>
                  producer.geometryGeoJson?.features?.map((feature) => ({
                    productionPlace: feature.properties?.productionPlace || '',
                    Area: feature.properties?.area || null,
                    type: feature.geometry?.type || '',
                    coordinates: feature.geometry?.coordinates || [],
                  })) || []
              ) || []
          )
        );

        setIsAccordionOpen(true);
        setValidationMessage('Validated Successfully');
      } else {
        setIsValidate(false);
        const errorMessage = response?.data?.message || 'Validation failed: Unknown error';
        setValidationMessage(errorMessage);
      }
    } catch (error) {
      setValidationMessage('Unexpected error occurred');
    }
  };

  useEffect(() => {
    if (toastOpen && manualEntryData && !submitError) {
      const timer = setTimeout(() => {
        dispatch({
          type: 'MANUAL_SUBMIT',
          payload: null,
        });

        navigate('/noneusuppliers');
        setToastOpen(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [toastOpen, manualEntryData, submitError]);

  useEffect(() => {
    dispatch(masterDataManual());
  }, []);

  manualEntryData?.supplierSuccessResponse &&
    setSubmitToastMessage(
      `DDS sent to Pending approval and frnId is:${manualEntryData?.supplierSuccessResponse?.frnId}`
    );

  useEffect(() => {
    if (!submitSuccess && submitError) {
      const errorCode = submitError?.response?.data?.errorCode;
      const errorDetails = submitError?.response?.message;
      if (errorCode === 400 && Array.isArray(errorDetails)) {
        const messages = errorDetails.map((e) => `• ${e.errorField}: ${e.errorMessage}`).join('\n');
        setSubmitToastMessage(`Validation Errors:\n${errorDetails}`);
      } else {
        setSubmitToastMessage('An unexpected error occurred.');
      }

      setToastOpen(true);
    }
  }, [submitError, submitSuccess]);

  const mapToManualSubmitPayload = (
    commodityFieldRows,
    { supplierRows, countryActivity, operatorRows, productRows, oldDdsRows }
  ) => {
    const supplier = supplierRows[0] || {};
    const country = countryActivity[0] || {};
    const operator = operatorRows[0] || {};
    const product = productRows[0] || {};
    const oldDds = oldDdsRows[0] || {};

    const commodities = commodityFieldRows.map((row) => ({
      hsHeading: row.hsHeader || '',
      descriptionOfGoods: row.descriptionOfGoods || '',
      itemSupplier: {
        itemNo: row.itemSupplier || '',
        itemType: '',
        classUnitClass: '',
        classUnitType: '',
        classUnitCode: '',
      },
      gtin: product.gtin || '1234567890123',
      validForBatchesFrom: product.validFrom || new Date().toISOString(),
      validForBatchesUntil: product.validUntil || new Date().toISOString(),
      volume: Number(row.volume) || 0,
      netWeight: Number(row.netWeight) || 0,
      supplementaryUnit: Number(row.numberofUnits) || 0,
      supplementaryUnitQualifier: 'EUR',
      speciesInfo: [
        {
          scientificName: 'Species scientific name',
          commonName: 'Species common name',
        },
      ],
      producers: row.producerAccordions.flatMap((accordion) =>
        accordion.producerRows.map((producer) => ({
          name: producer.producerName || '',
          country: producer.producerCountry || '',
          geometryGeoJson: {
            type: 'FeatureCollection',
            features: accordion.productionPlaceRows.map((place) => ({
              type: 'Feature',
              geometry: {
                type: place.geometryType || 'Point',
                coordinates:
                  typeof place.coordinates === 'string' && place.coordinates.trim() !== ''
                    ? JSON.parse(place.coordinates)
                    : place.coordinates || [],
              },
              properties: {
                productionPlace: place.productionPlace || '',
                Area: Number(place.area) || 0,

                harvestValidFrom: /^\d{4}-\d{2}-\d{2}$/.test(place.harvestValidFrom)
                  ? place.harvestValidFrom
                  : '2025-01-01',

                harvestValidTo: /^\d{4}-\d{2}-\d{2}$/.test(place.harvestValidTo)
                  ? place.harvestValidTo
                  : '2025-12-31',
              },
            })),
          },
        }))
      ),
    }));

    return {
      supplierId: supplier.supplierId || 'SUP12345',
      activityType: supplier.ddsActivityType || 'IMPORT',
      referenceNumber: supplier.ddsReferenceNumber || 'REF123456',
      verificationNumber: supplier.ddsVerificationNumber || 'VERIF12345',
      filingDate: supplier.ddsFilingDate || '2025-03-19T11:54:53.174Z',
      countryOfActivity: country.countryOfActivity || 'SE',
      borderCrossCountry: country.borderCrossCountry || 'NO',
      // validForCountries: [
      //   {
      //     countryCode: country.countryOfActivity || "SE"
      //   }
      // ],
      operator: {
        referenceNumber: {
          identifier: operator.operatorIdentifier || 'eori',
          value: operator.operatorValue || 'SE1234567890',
        },
        nameAndAddress: {
          name: operator.operatorName || 'Operator AB',
          country: operator.operatorCountry || 'SE',
          address: operator.operatoraddress || 'Main Street 1',
        },
      },
      commodities,
      associatedStatements: [
        {
          referenceNumber: oldDds.oldDdsFirstProduction || 'OLDREF001',
          verificationNumber: oldDds.oldDdsVerificationNumber || 'VERIF67890',
          activityType: oldDds.oldDdsActivityType || 'EXPORT',
          filingDate: oldDds.oldDdsFilingDate || '2025-03-19T11:54:53.174Z',
        },
      ],
    };
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(frnId).then(() => {
      setIsCopied(true);
      // setTimeout(() => setIsCopied(false), 2000);
    });
  };
  const handleFilingImport = () => {
    setIsFilingImport(true);
  };
  const handleManualSubmit = async () => {
    const payload = mapToManualSubmitPayload(commodityFieldRows, {
      supplierRows,
      countryActivity,
      operatorRows,
      productRows,
      oldDdsRows,
    });

    try {
      const response = await dispatch(manualSubmit(payload));
      if (response && response?.status === 200) {
        setSubmitSuccess(true);
        setSubmitError(null);
      } else if (response && response.status === 400) {
        setSubmitError({ response });
        setSubmitSuccess(false);
      } else {
        setValidationMessage('Validation failed: Unknown error');
      }
    } catch (error) {
      setSubmitError(error);
    }
  };

  const buttonData = [
    { label: 'Cancel', onClick: () => console.log('123') },
    { label: 'Submit', onClick: handleManualSubmit },
  ];
  const onClose = () => {
    setToastOpen(false);
  };
  return (
    <div style={{ maxWidth: 'auto' }}>
      <PageFEDSA style={{ display: 'flex', justifyContent: 'center' }}>
        <div className="manual-body">
          <FormField>
            <div>
              <SupplierDetails
                index={0}
                masterData={masterData}
                isFilingImport={isFilingImport}
                setIsFilingImport={setIsFilingImport}
                handleFilingImport={handleFilingImport}
                handleValidate={handleValidate}
                supplierRows={supplierRows}
                setSupplierRows={setSupplierRows}
                countryActivity={countryActivity}
                setCountryActivity={setCountryActivity}
                setCommodityRows={setCommodityRows}
                setOperatorRows={setOperatorRows}
                operatorRows={operatorRows}
                setIsValidate={setIsValidate}
                isValidate={isValidate}
              />
            </div>
            {(isValidate || isFilingImport) && (
              <>
                <AssociatedDds oldDdsRows={oldDdsRows} setOldDdsRows={setOldDdsRows} />
                <div>
                  <Commodities
                    productionPlaceRows={productionPlaceRows}
                    setProductionPlaceRows={setProductionPlaceRows}
                    producerRows={producerRows}
                    setProducerRows={setProducerRows}
                    isAccordionOpen={isAccordionOpen}
                    productRows={productRows}
                    setProductRows={setProductRows}
                  />
                </div>
                <div
                  style={{
                    marginTop: '10px',
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'flex-end',
                  }}
                ></div>
              </>
            )}
          </FormField>
          {buttonData.map((button, index) => (
            <Button
              key={index}
              className="demo-pill--stacking-story"
              iconPosition="leading"
              text={button.label}
              onClick={handleManualSubmit}
              size="small"
              type="emphasised"
            />
          ))}
          {manualEntryData && (
            <Toast
              text={
                <>
                  <strong>{submitToastMessage}</strong>
                </>
              }
              isOpen={toastOpen}
              actionClick={() => {}}
              onCloseRequest={onClose}
              ariaLabelCloseBtn="Dismiss notification"
            >
              {frnId && <Button onClick={copyToClipboard}>{isCopied ? '++' : 'Copy frnId'}</Button>}
            </Toast>
          )}
          {manualSubmit && submitSuccess && error && (
            <Toast
              text={
                <>
                  <strong>{submitToastMessage}</strong>
                </>
              }
              isOpen={toastOpen}
              actionClick={() => {}}
              onCloseRequest={onClose}
              ariaLabelCloseBtn="Dismiss notification"
            />
          )}
        </div>
      </PageFEDSA>
    </div>
  );
};
export default ManualEntry;
